import {
  EarningMechanismCreateMutationOptions,
  EarningMechanismDeleteMutationOptions,
  useEarningMechanismCreateMutation as useApolloEarningMechanismCreateMutation,
  useEarningMechanismDeleteMutation as useApolloEarningMechanismDeleteMutation,
} from '@occc/graphql';

import { useMutation } from '../utils';

export const useEarningMechanismCreateMutation = (
  baseOptions?: EarningMechanismCreateMutationOptions,
) => useMutation(useApolloEarningMechanismCreateMutation, baseOptions);

export const useEarningMechanismDeleteMutation = (
  baseOptions?: EarningMechanismDeleteMutationOptions,
) => useMutation(useApolloEarningMechanismDeleteMutation, baseOptions);
